import { render, staticRenderFns } from "./ExpedienteTable.vue?vue&type=template&id=1d13f66d"
import script from "./ExpedienteTable.vue?vue&type=script&lang=js"
export * from "./ExpedienteTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports